<template>
  <div class="flex flex-col h-full min-h-screen">
    <site-header />
    <div class="flex-grow bg-gray-50">
      <router-view />
    </div>
    <site-footer />
  </div>
</template>

<script>
  import SiteHeader from '@/components/SiteHeader'
  import SiteFooter from '@/components/SiteFooter'

  export default {
    name: 'SiteLayout',

    components: {
      SiteHeader,
      SiteFooter
    },

    async created () {
      await this.getVisitorInfo()
    },

    methods: {
      async getVisitorInfo () {
        const { data } = await this.$api.get('site/ip')

        if (data) {
          this.$cookies.set('country_code', data.iso)
          this.$cookies.set('country_name', data.countryName)
          this.$cookies.set('currency_code', data.currency)
          this.$cookies.set('currency_symbol', data.symbol)
        } else {
          this.$cookies.set('country_code', 'INTL')
          this.$cookies.set('country_name', 'International')
          this.$cookies.set('currency_code', 'EUR')
          this.$cookies.set('currency_symbol', '€')
        }
      }
    }
  }
</script>